import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Flame, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" data-testid="login-home-link" className="inline-flex items-center gap-2 text-zinc-400 hover:text-white font-mono-accent text-xs tracking-[0.2em] uppercase mb-10">
          <Flame className="w-4 h-4 text-[#ff5c00]" /> UGYC Dubai
        </Link>
        <div className="glass rounded-sm p-8 md:p-10">
          <p className="font-mono-accent text-xs tracking-[0.3em] uppercase text-[#ff5c00] mb-2">Admin</p>
          <h1 className="font-display text-3xl md:text-4xl uppercase tracking-tight mb-8">Sign In</h1>

          <form onSubmit={submit} className="space-y-5">
            <label className="block">
              <span className="font-mono-accent text-[10px] tracking-[0.25em] uppercase text-zinc-400 mb-2 block">Email</span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                className="w-full bg-[#0a0a0d] border border-white/10 px-4 py-3 text-sm text-white focus:outline-none focus:border-[#ff5c00] rounded-sm"
              />
            </label>
            <label className="block">
              <span className="font-mono-accent text-[10px] tracking-[0.25em] uppercase text-zinc-400 mb-2 block">Password</span>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="w-full bg-[#0a0a0d] border border-white/10 px-4 py-3 text-sm text-white focus:outline-none focus:border-[#ff5c00] rounded-sm"
              />
            </label>
            {error && <p data-testid="login-error" className="text-red-400 text-sm">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full inline-flex items-center justify-center gap-2 bg-[#ff5c00] hover:bg-[#ff7a33] disabled:opacity-60 text-white font-mono-accent text-xs tracking-[0.18em] uppercase px-5 py-4 rounded-sm transition-colors"
            >
              <LogIn className="w-4 h-4" /> {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
